// extracted by mini-css-extract-plugin
export default {"thumb":"CatalogThumb_thumb__KNY4D","thumbLg":"CatalogThumb_thumbLg__qWICY"};